<template>
  <div class="blessing" v-if="showData">
    <div v-if="showData.img">
      <van-overlay :show="show_bless" z-index="999">
        <div class="blessBox">
          <div>
            <div class="content">
              <div class="img">
                <img :src="showData.img" alt="" />
              </div>
            </div>
            <div class="btns b pa">
              <div class="btn notips" @click="notips()">
                不再提醒
              </div>
              <div class="btn close" @click="close()">
                谢谢
              </div>
            </div>
          </div>
        </div>
      </van-overlay>
    </div>
    <div v-if="showData.text">
      <van-dialog
        class="dia"
        v-model="show_bless"
        :title="showData.title"
        :message="showData.text"
        :confirm-button-text="showData.confimText"
        :cancel-button-text="showData.closeText"
        :show-cancel-button="true"
        @confirm="close()"
        @cancel="notips()"
      >
      </van-dialog>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { Overlay, Dialog } from 'vant';
import localStorage from '@/utils/storage/localStorage';
// import default_img from '@/assets/images/common/birthday_bless.jpg'

import moment from 'moment';
Vue.use(Overlay, Dialog);

export default {
  name: 'staticBless',
  props: {
    showflag: {},
    img: {
      type: String,
      default: ''
    },
    custom_id: {
      type: String,
      default: ''
    },
    pData: {}
  },
  data() {
    return {
      // default_img,
      info: '',
      show_bless: false,
      show_img: null,
      show_text: '',
      handleData: null,
      chooseIdx: 0
    };
  },
  computed: {
    showData() {
      if (this.pData) return this.pData;
      return null;
    }
  },
  watch: {
    $route: {
      handler(val) {
        if (val) {
          let flag = localStorage.get('festival_pop_flag');
          if (!flag) {
            this.show_bless = true;
          }
        }
      },
      immediate: true,
      deep: true
    },
    pData: {
      handler(val) {
        if (val) {
          const { text } = val;
          this.show_text = text;
        }
      },
      immediate: true
    },
    img: {
      handler(val) {
        if (val) {
          this.show_img = val;
        }
      },
      immediate: true
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.showBless()
    // }, 1000)
  },
  methods: {
    showBless() {
      let bless_time = localStorage.get('static_bless_time');
      if (bless_time) {
        let oldTime = bless_time.time;
        let nowTime = moment()
          .subtract(10, 'days')
          .calendar();
        if (oldTime == nowTime) {
          // 同一天，不再提示
          return;
        } else {
          // 重置标记
          localStorage.remove('static_bless_time');
          this.set_custom_show(false);
        }
      } else {
        this.set_custom_show(false);
      }
    },
    close() {
      this.show_bless = false;
    },
    notips() {
      localStorage.set('festival_pop_flag', true);
      this.show_bless = false;
    },
    set_custom_show(flag) {
      if (this.custom_id) {
        let data = this.get_custom_show();
        data[this.custom_id] = flag;
        localStorage.set('custom_show_static_bless', data);
      }
    },
    get_custom_show() {
      let data = localStorage.get('custom_show_static_bless');
      if (data) return data;
      return {};
    }
  }
};
</script>
<style lang="scss" scoped>
.blessing {
  .dia {
    /deep/.van-dialog__message {
      text-align: left;
    }
  }
  .blessBox {
    margin: auto;
    width: 300px;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    .content {
      border-radius: 15px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .btns {
      margin: auto;
      margin-top: 30px;
      .btn {
        border: 1px solid;
        border-radius: 50px;
        width: 100px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;
      }
      // .notips {
      //   background: #fff;
      //   color: #333333;
      // }
      .close {
        background: #fff;
        color: #333333;
      }
    }
  }
}
</style>
